import { render, staticRenderFns } from "./mainAccountLog.vue?vue&type=template&id=06a57cbe&scoped=true&"
import script from "./mainAccountLog.vue?vue&type=script&lang=js&"
export * from "./mainAccountLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a57cbe",
  null
  
)

export default component.exports